import { createFileRoute, redirect } from "@tanstack/react-router";
import { OpenAPI } from "@/client";
import { OpenAPI as OpenAPIAdmin } from "@/client-admin";

export const Route = createFileRoute("/logout")({
  beforeLoad: () => {
    localStorage.removeItem("access_token");
    OpenAPI.TOKEN = undefined;
    OpenAPIAdmin.TOKEN = undefined;
    return redirect({ to: "/login" });
  },
});
